import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { createChainedFunction } from '@atc/create-chained-function';
import Collapse from '../Collapse/index.js';

/**
 * Collapsible is a controlled implementation using the react-bootstrap Collapse component.
 * Its general use is to toggle between showing and hiding content. This content will be supplied to the component as children.
 * Trigger nodes may also be supplied to the component as can their location, above or below the content.
 *
 */
function Collapsible(_ref) {
  let {
    children,
    initialCollapse = true,
    onToggle,
    toggleHeader,
    toggleFooter,
    ...rest
  } = _ref;
  const [isOpen, setIsOpen] = useState(!initialCollapse || false);
  const handleToggle = () => {
    setIsOpen(prevState => !prevState);
  };
  const renderToggle = toggleContent => /*#__PURE__*/_jsx("div", {
    onClick: createChainedFunction(handleToggle, onToggle),
    role: "button",
    tabIndex: "0"
  }, void 0, toggleContent);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    "data-cmp": "collapsible"
  }, rest), toggleHeader && renderToggle(toggleHeader), /*#__PURE__*/_jsx(Collapse, {
    in: isOpen
  }, void 0, children), toggleFooter && renderToggle(toggleFooter));
}
export default Collapsible;